import styles from "./Efficiency.module.scss";
import EfficiencySVG from "../assets/efficiency/efficiency.png";

export const Efficiency = () => {
  return (
    <div className={styles.efficiency}>
      <div>
        <div className={styles.content}>
          <h2>
            <span className={`gradient ${styles.bold}`}>
              DeFi's Most Efficient Liquidity.
            </span>{" "}
            Period.
          </h2>
          <p>
            Hashflow is the fastest way to offer better prices, deeper
            liquidity, and a premium experience— without building an RFQ engine
            from scratch.
          </p>
        </div>
        <img src={EfficiencySVG} alt="Efficiency" height={175} />
      </div>
    </div>
  );
};
